export type Role = 'STUDENT' | 'TEACHER' | 'ADMIN';

type RoleInput = string | undefined;

export function normalizeRole(role: RoleInput): Role {
  if (!role) {
    return 'STUDENT';
  }

  const normalized = role.toUpperCase();
  if (normalized === 'ADMIN' || normalized === 'TEACHER' || normalized === 'STUDENT') {
    return normalized;
  }

  return 'STUDENT';
}

export function isAdminRole(role: RoleInput) {
  return normalizeRole(role) === 'ADMIN';
}

export function roleLabel(role: RoleInput) {
  const normalized = normalizeRole(role);
  if (normalized === 'ADMIN') {
    return '管理员';
  }
  if (normalized === 'TEACHER') {
    return '教师';
  }
  return '学生';
}
